import React from "react";
import "./Dealine_ScrollBar.css";

function Deadline(props) {
  return (
    <div className="ttip">
      <p className="mb-0 cursor-pointer" key={props.deadline.title}>
        {props.deadline.title}
      </p>
      <span className="ttip-text ttp">{props.deadline.tooltip}</span>
    </div>
  );
}

export default Deadline;
